var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2598 3.14466L3.75977 3.14626C2.93134 3.14638 2.25987 3.81806 2.25999 4.64648L2.26159 15.1465C2.26172 15.9749 2.9334 16.6464 3.76182 16.6463L14.2618 16.6447C15.0902 16.6445 15.7617 15.9729 15.7616 15.1444L15.76 4.64443C15.7599 3.816 15.0882 3.14453 14.2598 3.14466Z",
    stroke: "#4C4C4C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.26172 7.64648L15.7617 7.64443",
    stroke: "#4C4C4C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.76309 16.6455L6.76172 7.64551",
    stroke: "#4C4C4C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/layout.23a0cb5df3b79353ac76cff2d99ccfc4.svg";
export { ForwardRef as ReactComponent };